import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ClassCountTuitionRange {
  _id: string;
  minClasses: number;
  maxClasses: number;
  flatRate: number;
}

export interface ClassCountTuitionBilling {
  _id: string;
  name: string;
  studioId: string;
  aggregation?: 'family';
  ranges: Array<ClassCountTuitionRange>;
  createdAt: string;
  updatedAt: string;
}

export const getClassCountTuitionBilling = async () => {
  const response = await baseAPI.get<Array<ClassCountTuitionBilling>>(
    'class-count-tuition-billing',
  );
  return response.data;
};

export const useGetClassCountTuitionBilling = (enabled = true) => {
  return useQuery({
    queryKey: [KEYS.CLASS_COUNT_TUITION_BILLING],
    queryFn: () => getClassCountTuitionBilling(),
    enabled,
  });
};
